export default __webpack_public_path__ + "static/media/img_07.716d9099.jpg";